import { Box, Text, HStack, Image } from "@chakra-ui/react";
import "./StepsIndicator.scss"

export const StepsIndicator = ({isCollapsed, publisher}) => {
  return (
    <Box className="animated-border" mb={5}>
      <HStack spacing={3}>
        <Image src="/images/rocket.svg" width="24px"/>
        {!isCollapsed && <Box>
          <Text fontSize="sm" fontWeight="bold">
            Step  
            <Text as="span"> {`${publisher?.otherInfo?.isStoreSettingComplete ? 2 : 1}`}</Text> / 3
          </Text>
          <Text fontSize="xs">
            Set up your Edshop
          </Text>
        </Box>}
      </HStack>
    </Box>
  );
};
